import React, { ReactElement, ReactNode, useEffect } from 'react';
import QuestionPanel from "../../structure/QuestionPanel";
import { FormValues } from "../../common/FormValues";
import DocumentUpload from "../../input/DocumentUpload";
import AddListElementButton from "../../button/AddListElementButton";
import { UploadedDocument } from "../../domain/UploadedDocument";
import { DocumentType } from "../../enums/DocumentType";
import { hasRequiredDocumentsFor } from "../../enums/BenefitType";
import { useFormikContext } from "formik";

export type DocumentProps = {
    documentDescription?: ReactNode,
    documentTypeOptions: DocumentType[],
    panelContent?: ReactElement | boolean,
}

const Document = (props: DocumentProps) => {
    const { values, setFieldValue } = useFormikContext<FormValues>()
    const { documentDescription, documentTypeOptions, panelContent } = props;

    const firstDocumentType = documentTypeOptions[0];
    useEffect(() => {
        setFieldValue('defaultDocumentType', firstDocumentType)
    }, [setFieldValue, firstDocumentType])

    const headerText = hasRequiredDocumentsFor(values) ?
        "Please upload any documents to support your claim." :
        "Do you have documents to upload?";
    const documentTypesWithOther = [...documentTypeOptions, DocumentType.OTHER]
    return (
        <QuestionPanel headerText={headerText}
                       detailsText={
                           <div className="flex-gap">
                               {documentDescription && <div>{documentDescription}</div>}
                               <div>Additional supporting documentation can also be emailed to SBDClaims@principal.com or faxed to 800-255-6609. Please be sure to include your name and phone number with all documents that are submitted.</div>
                               <div>PDF files are supported, with a total maximum file size of 3MB.</div>
                           </div>}
                       panelContent={
                           <>
                               <AddListElementButton idPrefix="documents"
                                                     componentType={DocumentUpload}
                                                     elementInitialValue={{
                                                         document: '',
                                                         documentContent: '',
                                                         documentType: ''
                                                     } as UploadedDocument}
                                                     buttonText="Add Document"
                                                     otherElementProps={documentTypesWithOther}/>
                               {panelContent}
                           </>
                       }
        >
        </QuestionPanel>
    )
};

export default Document;